import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

export default function AudioModal(props) {

    let {
        bgColor='primary',
        textColor='secondary',
        audioFile,
        mimeType,
        text,
        show } = props;

    useEffect(() => {
        if(show) {
            document.body.style.overflow = 'visible';
        }
    });

    return (
        <Modal
            show={show}
            backdrop={false}
            keyboard={false}
            fullscreen={false}
            autoFocus={false}
            enforceFocus={false}
            size={'sm'}
            id={'audio-modal'}
            animation={true}
            dialogClassName={`position-fixed m-0 bottom-5 end-5`}
            contentClassName={'bg-transparent position-relative'}
            className={'justify-content-center w-auto h-auto'}
            onHide={() => props.onHide()}>
            <audio controls title={text} className={bgColor} controlsList="nodownload" autoPlay>
                <source src={audioFile} type={mimeType} />
            </audio>
            <a className={'position-absolute top-0 end-0 link-secondary'} onClick={() => props.onHide()}>
                <i className={'fas fa-circle-xmark fs-5'}></i>
            </a>
        </Modal>
    )
}
